import { render, staticRenderFns } from "./MultiSelectField.vue?vue&type=template&id=72fa2c1b&scoped=true&"
import script from "./MultiSelectField.vue?vue&type=script&lang=js&"
export * from "./MultiSelectField.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectField.vue?vue&type=style&index=0&id=72fa2c1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa2c1b",
  null
  
)

export default component.exports